import type { FC } from "react";

import type { ExtendedColumnsType } from "../../Table";
import { PropertyTable } from "../../Table/components/PropertyTable";
import { displayDateTimeValue, displayEnumValue } from "../../Table/components/PropertyTable/transformations/cellTransformations";
import type { ChangeLogEntryEntity } from "../types/ChangeLogEntryEntity";

interface ChangeLogTableProps {
    datasource?: ChangeLogEntryEntity[];
}

const getColumnsConfig = (t: Function): ExtendedColumnsType<ChangeLogEntryEntity>[] => [
    {
        title: t("user.log.form.username"),
        dataIndex: "username",
        key: "username",
    },
    {
        title: t("user.log.form.revisionType"),
        dataIndex: "revisionType",
        key: "revisionType",
        render: (value) => displayEnumValue(value, "revision-types"),
    },
    {
        title: t("history.table.className"),
        dataIndex: "className",
        key: "className",
    },
    {
        title: t("user.log.table.created"),
        dataIndex: "changed",
        key: "changed",
        render: (value) => displayDateTimeValue(value),
    },
    {
        title: t("user.log.table.changes"),
        dataIndex: "changes",
        key: "changes",
    },
];

export const ChangeLogTable: FC<ChangeLogTableProps> = ({ datasource }) => {
    return (
        <PropertyTable<ChangeLogEntryEntity>
            name="changeLog_table"
            getColumnsConfig={getColumnsConfig}
            tableData={datasource ?? []}
            propertyAsRowKey={"id"}
            pagination={{ showSizeChanger: true }}
            readOnly={false}
            rowsAreSelectable={false}
        />
    );
};
